var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGolf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#727831",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.404 37.266v.62c0 1.72 1.379 3.114 3.08 3.114h7.112V22.702H19.404v6.072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.457 28.773v6.982c0 .834-.555 1.51-1.24 1.51H17.35v-8.492h4.106zM29.596 38.838l3.789-1.764v-8.11l-3.79-1.764M19.404 26.044h10.192M26.813 22.702V16.02l4.653-.618a2.41 2.41 0 0 0 2.038-1.92c.19-.935-.517-1.81-1.46-1.81h-.933c-2.374 0-4.298 1.947-4.298 4.348M22.187 22.702v-4.347l-4.653-.618a2.41 2.41 0 0 1-2.038-1.92c-.19-.935.517-1.81 1.46-1.81h.933c2.374 0 4.298 1.947 4.298 4.348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.496 22.702V11.347l-4.653-.618a2.41 2.41 0 0 1-2.038-1.92C17.616 7.874 18.322 7 19.265 7h.933c2.374 0 4.298 1.946 4.298 4.347"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolf);
export default __webpack_public_path__ + "static/media/golf.389071b5fbd7d49aa3fe4b1ed6bb0cca.svg";
export { ForwardRef as ReactComponent };